import apiService from "./apiService"

const providersApiSlice = apiService.injectEndpoints({
  endpoints: (builder) => ({
    fetchProviders: builder.query({
      query: (query) => ({ url: "providers", params: query }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    fetchLocations: builder.query({
      query: () => ({ url: "location" }),
      transformResponse: (response, meta, arg) => response.data,
    }),
    hardSyncProviders: builder.mutation({
      query: (practices) => ({
        url: "providers/hardsync",
        method: "POST",
        body: { practices },
      }),
      transformResponse: (response, meta, arg) => response.data,
    }),
  }),
})

export default providersApiSlice

export const {
  useLazyFetchProvidersQuery,
  useLazyFetchLocationsQuery,
  useHardSyncProvidersMutation,
} = providersApiSlice

export const {} = providersApiSlice
